import { de } from './de';
import { en } from './en';
import { fr } from './fr';
import { it } from './it';
/**
 * The translation interface.
 */
export class I18n {
    /**
     * Create a new I18n instance.
     * @param language - The initial language.
     */
    constructor(language) {
        this.assertIsValidLanguage(language);
        this.language = language;
    }
    /**
     * Get the translation for the given key.
     * @param key - The translation key.
     * @returns The translated string.
     */
    translate(key) {
        this.assertIsValidTranslationKey(key);
        const translations = I18n.translations[this.language];
        return translations[key];
    }
    /**
     * Assert that the passed language key is valid/available.
     * @param language - The language key.
     */
    assertIsValidLanguage(language) {
        // Warn user if there are no translations for the given language.
        if (!I18n.translations.hasOwnProperty(language)) {
            throw new Error(`There are no translations for the given language ${language}.`);
        }
    }
    /**
     * Assert that the passed translation key is valid/available.
     * @param key - The translation key.
     */
    assertIsValidTranslationKey(key) {
        if (I18n.translations[this.language][key] === undefined) {
            throw new Error(`Could not find the translation for key ${key}`);
        }
    }
}
/**
 * The available translations.
 */
I18n.translations = {
    de,
    en,
    fr,
    it,
};
//# sourceMappingURL=index.js.map